import { render, staticRenderFns } from "./TextBlockWithLabel.vue?vue&type=template&id=e5027430&"
import script from "./TextBlockWithLabel.vue?vue&type=script&lang=js&"
export * from "./TextBlockWithLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports